/**
 * Product Types
 * Ürün kategorileri
 */
export const ProductType = {
  BUS: "bus",
  FERRY: "ferry",
  FLIGHT: "flight",
  CAR: "car",
  HOTEL: "hotel",
};
